import { ErrorHandler, Injectable, inject } from '@angular/core';
import { AWSLoggerService } from './core/services/aws.logger.service';
import { GoogleAnalyticsEvent } from './shared/enums/google-analytics-event.enum';
import { trackEvent } from './core/services/google-analytics';

@Injectable()
export class LoggerErrorHandler implements ErrorHandler {
  private readonly loggerService = inject(AWSLoggerService);

  async handleError(error: unknown) {
    console.error(error);
    this.loggerService.logError(error, { source: 'global-error-handler' });
    trackEvent(GoogleAnalyticsEvent.EXCEPTION, {
      description:
        error instanceof Error
          ? error.message
          : String(error ?? 'Unknown Error'),
      fatal: false,
    });
  }
}
